import FormSingleDropzone from "@form/FormSingleDropzone/FormSingleDropzone";

export default FormSingleDropzone;